module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA9CAYAAADMMmuxAAAA90lEQVR4AezXJVAGARTE8U/ubrhGgki/hHRcC94L1xO9UfE+g0smUXDpfci4NmxZLOHvmNnyduaf3y+d5P5rAIosYvEfCrMcLGVdbI6dwbYxy+EKtgLb7AAAeTYE++wAAAW2yqACTDNIAADqGCQAAHl2ogRUMSgBI2rAlQwAoIhs62clLP9d3wEC2NeQMy874I7llYD9HKcE7DjAAX891MjSTxqEbUcs/WU1BGAZug2oAc1qQKIGlKkBsRpQUAJucpwSsK4GTL4DElb/SR2w7YBV/aLy3/wT6F5GDnCAAxzgAAc4wAEOcIADHOAAB7whYkNPYyfFDgDv0v9gEa7LmgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook-icon.png
// module id = 173
// module chunks = 35783957827783 112966903596346 114276838955818